(function ($) {

    function propertiesSlider() {
        $(".product-property-animated-slider").each(function () {
            var $this = $(this);
            var infoSlider = new Swiper($this.find('.swiper-container').get(0), {
                slidesPerView: 'auto',
                freeMode: true,
                spaceBetween: 8,
                // observer: true,
                // watchOverflow: true,
                // watchSlidesVisibility: true,
                threshold: 20,
                mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 20,
                    thresholdTime: 0.1,
                },
                scrollbar: {
                    el: $this.find('.swiper-scrollbar')[0],
                    hide: false,
                    draggable: true,
                },
                navigation: {
                    nextEl: $this.find(".swiper-button-next").get(0),
                    prevEl: $this.find(".swiper-button-prev").get(0),
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 12,
                    },
                },
                on: {
                    reachEnd: function () {
                        this.el.classList.add('-end');
                    },
                    fromEdge: function () {
                        this.el.classList.remove('-end');
                    }
                }
            });
            // window.onresize = function () {
            //     infoSlider.update();
            // }
            if ($this.find(".swiper-slide").length === 1) {
                infoSlider.destroy();
            }
        });
    }


    $(document).gp_ready(function () {
        propertiesSlider();
    })

    var w = $(window).width();
    window.addEventListener('resize', () => {
        clearTimeout(window.resizedFinished);
        if ($(window).width() === w) return;
        w = $(window).width();
        window.resizedFinished = setTimeout(function () {
            propertiesSlider();
        }, 250);
    });

})(jQuery);
